<template>
  <div>
    <a-descriptions bordered size="small" title="" :column="5">
      <a-descriptions-item label="S/N码">{{ model.sn }}</a-descriptions-item>
      <a-descriptions-item label="采购类型">{{ model.purchaseType }}</a-descriptions-item>
      <a-descriptions-item label="合同编号">{{ model.contractNumber }}</a-descriptions-item>
      <a-descriptions-item label="合同名称">{{ model.contractName }}</a-descriptions-item>
      <a-descriptions-item label="合同价格">{{ model.contractPrice }}</a-descriptions-item>
      <a-descriptions-item label="售后服务类型">{{ model.serviceType }}</a-descriptions-item>
      <a-descriptions-item label="维修合同到期">{{ model.maintenanceDate}}</a-descriptions-item>
      <a-descriptions-item label="采购订单编号">{{ model.purchaseOrder }}</a-descriptions-item>
      <a-descriptions-item label="供应商名称">{{ model.supplier }}</a-descriptions-item>
      <a-descriptions-item label="供应商编号">{{ model.supplierNumber }}</a-descriptions-item>
      <a-descriptions-item label="购置价值(万元)">{{ model.kansw }}</a-descriptions-item>
      <a-descriptions-item label="购置净值">{{ model.qmzj }}</a-descriptions-item>
      <a-descriptions-item label="税率">{{ model.taxRate }}</a-descriptions-item>
      <a-descriptions-item label="购置日期">{{ model.purchaseDate}}</a-descriptions-item>
      <a-descriptions-item label="采购人">{{ model.buyer }}</a-descriptions-item>
<!--      <a-descriptions-item label="入库单号">{{ model.warehouseNumber }}</a-descriptions-item>-->
<!--      <a-descriptions-item label="验收人">{{ model.accepterName }}</a-descriptions-item>-->
<!--      <a-descriptions-item label="WBS编号">{{ model.wbsNumber }}</a-descriptions-item>-->
    </a-descriptions>
<!--    <a-descriptions bordered size="small" title="出厂信息" :column="5">-->
<!--      <a-descriptions-item label="生产厂家">{{ model.manufactureFactory }}</a-descriptions-item>-->
<!--      <a-descriptions-item label="出厂日期">{{ model.dateInProduced }}</a-descriptions-item>-->
<!--      <a-descriptions-item label="出厂编号">{{ model.factoryNumber }}</a-descriptions-item>-->
<!--      <a-descriptions-item label="供应技术资料说明">{{ model.instructionBook }}</a-descriptions-item>-->
<!--      <a-descriptions-item label="入库日期">{{ model.arrivalDate}}</a-descriptions-item>-->
<!--      <a-descriptions-item label="购置日期">{{ model.purchaseDate}}</a-descriptions-item>-->
<!--      <a-descriptions-item label="到货日期">{{ model.deloveryDate}}</a-descriptions-item>-->
<!--      <a-descriptions-item label="生产日期">{{ model.producedDate}}</a-descriptions-item>-->
<!--      <a-descriptions-item label="出库日期">{{ model.outboundDeliveryDate}}</a-descriptions-item>-->
<!--      <a-descriptions-item label="拨交日期">{{ model.dateOfDelivery}}</a-descriptions-item>-->
<!--      <a-descriptions-item label="报废日期">{{ model.retirementDate}}</a-descriptions-item>-->
<!--      <a-descriptions-item label="资本化日期">{{ model.capitalizationDate}}</a-descriptions-item>-->
<!--      <a-descriptions-item label="投用日期">{{ model.entryDate}}</a-descriptions-item>-->
<!--      <a-descriptions-item label="维保合同到期">{{ model.maintenanceDate}}</a-descriptions-item>-->
<!--      <a-descriptions-item label="注册代码">{{ model.registerCode }}</a-descriptions-item>-->
<!--      <a-descriptions-item label="使用登记证号">{{ model.certificateNumber }}</a-descriptions-item>-->
<!--      <a-descriptions-item label="全国检验报告编号">{{ model.inspectionReportNumber }}</a-descriptions-item>-->
<!--      <a-descriptions-item label="外观质量">{{ model.quality }}</a-descriptions-item>-->
<!--      <a-descriptions-item label="特种设备类型">{{ model.specialEquipmentType }}</a-descriptions-item>-->
<!--      <a-descriptions-item label="是否校准/定检">{{ model.ifverify }}</a-descriptions-item>-->
<!--    </a-descriptions>-->
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        console.log('watch_record', model)
        this.initDetail(model)
      },
      immediate: true
    }
  },
  data () {
    return {
      detail: {
        xxx: 'xxxxxx'
      }
    }
  },
  methods: {
    initDetail (model) {
      this.model.purchaseDate = model.purchaseDate ? moment(model.purchaseDate).format('YYYY-MM-DD') : ''
      this.model.maintenanceDate = model.maintenanceDate ? moment(model.maintenanceDate).format('YYYY-MM-DD') : ''
    }
  }
}
</script>

<style scoped>

</style>
